<template>
    <div data-cy="container_campaign_favourite_list">
        <div class="grid grid-cols-2 gap-4" data-cy="list_campaign_favourite">
            <CampaignItem
                    :data-cy="`card_campaign_item_${index}`"
                    v-for="(campaign, index) in campaigns"
                    :key="campaign.id"
                    :campaign="campaign"
                    :isFavourite="true"
            ></CampaignItem>
        </div>

        <div v-if="isLoaded && !isHaveItem" data-cy="container_campaign_favourite_empty">
            <Nodata
                :textData="lbl.no_data"
                :isTextOnly="true" />
        </div>
    </div>
</template>
<script>
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//component
import CampaignItem from './CampaignItem.vue';
import Nodata from '@/components/Layout/Page/NoData.vue';
//service
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';

/**
 * @event onLoaded
 */
export default {
    name: "CampaignFavouriteList",
    mixins: [LocaleMixin, ModalMixin],
    components: {
        CampaignItem,
        Nodata,
    },
    data: function() {
        return {
            campaigns: [],

            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
        };
    },
    created: function() {
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;

        this.getList();
    },
    methods: {
        getList: function() {
            return new Promise((resolve) => {
                this.isLoading = true;
                this.modal.loadingModal.show();
                BzbsCampaign.apiGetFavouriteList().subscribe({
                    next: (campaigns) => {

                        for (var campaign of campaigns) {
                            //TODO: Add GA Tracking.
                            this.campaigns.push(campaign);
                        }

                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = this.campaigns.length > 0
                            ? true
                            : false;

                        resolve();
                        this.modal.loadingModal.hide();
                        this.$emit('onLoaded');
                    },
                    error: (err) => {
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;

                        if(err.id == 401){
                            this.$router.push('/error');
                        }else{
                            this.errorApi(err);
                        }

                        this.modal.loadingModal.hide();
                        this.$emit('onLoaded');
                        resolve();
                    },
                });
            });
        },

        loadMore: async function() {
            // console.log('load more list', this.listConfig.isSeeMoreEnable);
            // if (!this.listConfig.isSeeMoreEnable || this.isLoading) {
            //     return;
            // }

            this.modal.loadingModal.show();
            await this.getList();
            this.modal.loadingModal.hide();
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
